/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import { CatalogoInventario } from "modules/catalogoInventario";

function InventarioPage(): JSX.Element {
  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%", mt: 1 }}>
              <Typography variant="h4" gutterBottom sx={{ color: "#004c93" }}>
                Catálogo de Productos
              </Typography>
            </Grid>
            <CatalogoInventario />
          </CardContent>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default InventarioPage;